import { render, staticRenderFns } from "./PointEmptyLink.vue?vue&type=template&id=def3b230&scoped=true&"
import script from "./PointEmptyLink.vue?vue&type=script&lang=js&"
export * from "./PointEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def3b230",
  null
  
)

export default component.exports